import React from 'react';
import PropTypes from 'prop-types';

import {
  Box,
  Chip
} from '@mui/material';

import { chipContainerSx } from './styles';

const StatusChips = ({
  items,
  rows,
  activeValue,
  onChange
}) => {
  const getCount = value => {
    if (value === 'All' || value === 'ALL') {
      return rows.length;
    }

    return rows.filter(row => row.status === value).length;
  };

  return (
    <Box sx={chipContainerSx}>
      {items.map(item => {
        const isActive = activeValue === item.value;

        return (
          <Chip
            key={item.value}
            clickable
            icon={React.cloneElement(item.icon, {
              sx: {
                color: item.textColor || '#424242',
                fontSize: 18
              }
            })}
            label={`${item.label} (${getCount(item.value)})`}
            onClick={() => onChange(item.value)}
            sx={{
              height: 32,
              px: 0.5,
              bgcolor: isActive
                ? item.activeBackground
                : item.background,
              border: `1px solid ${
                isActive ? item.activeBorder : item.border
              }`,
              borderRadius: '4px',
              color: item.textColor || '#424242',
              fontSize: 11,
              fontWeight: 500,
              textTransform: 'uppercase',

              '& .MuiChip-label': {
                px: 1
              },

              '& .MuiChip-icon': {
                ml: 0.5
              },

              '&:hover': {
                bgcolor: isActive
                  ? item.activeBackground
                  : item.background
              }
            }}
          />
        );
      })}
    </Box>
  );
};

StatusChips.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
      icon: PropTypes.element.isRequired,
      background: PropTypes.string.isRequired,
      activeBackground: PropTypes.string.isRequired,
      border: PropTypes.string.isRequired,
      activeBorder: PropTypes.string.isRequired,
      textColor: PropTypes.string
    })
  ).isRequired,
  rows: PropTypes.arrayOf(
    PropTypes.shape({
      status: PropTypes.string.isRequired
    })
  ).isRequired,
  activeValue: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
};

export default StatusChips;